<!-- <div class="col-md-8 col-md-offset-1" *ngIf="!bookingInit || !copyLoaded || !pricingInit">
  <div class="loader-container">
    <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div>
  </div>
</div> -->

<div class="col-md-8 col-md-offset-1 fadeInUp" *ngIf="bookingInit && copyLoaded && pricingInit">

  <div [class.formHidden]="showChallengeShopper">

    <app-language-selector></app-language-selector>

    <button id="collection-back" type="button"
      class="btn btn-link hidden-sm hidden-xs back-btn" *ngIf="bookingType !== 'amend'" (click)="goPanelBack()">
      <i class="icon">chevron_left</i>{{appCopy.panelHeader['linkBack'+selectedLanguage]}}
    </button>
    <button id="add-payment-back" type="button" class="btn btn-link back-btn"
    *ngIf="bookingType === 'amend'" (click)="cancelAmend()">
    <i class="icon">chevron_left</i>
    {{appCopy.panelHeader['linkCancel'+selectedLanguage]}}
    </button>

    <ng-template [ngIf]="bookingState.bookingDetails.bookingAmendType === 'refund'" [ngIfElse]="notRefund">
      <h1 class="text-dark-blue h1">{{appCopy.panelHeader['titleRefund'+selectedLanguage]}}</h1>
    </ng-template>

    <ng-template #notRefund>
      <h1 class="text-dark-blue h1">{{appCopy.panelHeader['title'+selectedLanguage]}}</h1>
    </ng-template>

    <p class="margin-bottom-8 text-dark-blue" [ngClass]="{
          'margin-bottom-32': bookingType === 'amend'
        }">{{appCopy.panelHeader['content'+selectedLanguage]}}</p>

    <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="margin-bottom-32 text-dark-green">
      <i class="icon icon-cut-off-checkmark"></i> {{appCopy.panelHeader['cutOfTiming'+selectedLanguage].replace('%s', cutOffTimeWindowDate).replace('%s', cutOffTimeWindowTime)}}</p>
    <div class="flex-always flex--space-between margin-bottom-16">
      <h5 *ngIf="bookingAmendSection === 'booker' || bookingAmendSection === ''"
        class="margin-top-0 margin-bottom-0 text-dark-blue">{{appCopy.panelHeader['yourDetailsTitle'+selectedLanguage]}}
      </h5>
    </div>
      <!-- miles-and-more -->
      <app-miles-and-more-pay
        *ngIf="(milesLoaded === 'success' || milesLoaded === 'low_price' || milesLoaded === 'low_miles') && milesReducer.canPayWithMiles && milesReducer.isUserLoggedIn"
        [appCopy]="appCopy"
        [selectedLanguage]="selectedLanguage">
      </app-miles-and-more-pay>
      <div *ngIf="!milesReducer.isUserLoggedIn && canDoMilesLogin && price.totalPrice.majorAmount > 0 && bookingState.bookingDetails.bookingAmendType !== 'refund' && bookingAmendSection !== 'booker' && milesLoaded !== 'success'" class="margin-bottom-8 ng-star-inserted">
      <!-- <div class="col-lg-6 col-md-6 margin-bottom-16"></div> -->
        <div id="miles-section" class="col-lg-12 col-md-12 margin-bottom-16 miles-section">
            <div class="flex-always miles-header flex--wrap flex--space-between">
              <span class="title">{{appCopy.panelHeader['spenMilesTitle'+selectedLanguage]}}</span>
              <span>
                <img
                class="miles-logo"
                src="./images/Miles-More-Logo.png"
                alt="Miles-More-Logo"
                />
              </span>
            </div>
            <button (click)="milesLoginRedirect()" type="button" class="btn btn-mile-more ng-star-inserted">
              {{appCopy.panelHeader['milesLoginBtn'+selectedLanguage]}}
              <div class="loader-container-btn" *ngIf="milesLoaded === 'loading'">
                <div class="loader loader--gray">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" />
                  </svg>
                </div>
              </div>
            </button>
            <div *ngIf="bookingType !== 'amend'" class="flex-always flex--wrap mile-promo flex--space-between">
              <span>{{appCopy.panelHeader['milesPromoTitle'+selectedLanguage]}}</span>
              <button (click)="scrollToPromoField()" class="btn ng-star-inserted promo-btn">{{appCopy.panelHeader['milesPromoBtn'+selectedLanguage]}}</button>
            </div>
        </div>
      </div>
      <!-- miles-and-more -->

      <div class="panel panelPaymentOption" *ngIf="bookingType !== 'amend' && bookingAmendSection !== 'booker'">
        <h5 class="checkoutTitle">{{appCopy.panelHeader['checkoutExpressTitle'+selectedLanguage]}}</h5>
        <form #termsFormExpresscheckout="ngForm" name="termsFormExpresscheckout" class="termsFormExpresscheckout" ng novalidate *ngIf="bookingType !== 'amend'">
          <ul class="list-group margin-bottom-0">
            <li class="list-group-item mb-5">
                <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                  <input type="checkbox" [ngClass]="{ 'has-error' : DataSharingAllowedCheckoutExpress.dirty && DataSharingAllowedCheckoutExpress.invalid }"
                  name="dataSharingAllowedCheckoutExpress" id="dataSharingAllowedCheckoutExpress" #DataSharingAllowedCheckoutExpress="ngModel" [ngModel]='upsellFormData.set' required
                  (change)="iUnderstand($event)">
                  <label for="dataSharingAllowedCheckoutExpress" class="text-caption">
                    {{appCopy.panelHeader['dataSharingAllowedCheckLabel'+selectedLanguage]}}
                  </label>
                </div>
                <p class="help-block text-danger" *ngIf="DataSharingAllowedCheckoutExpress.dirty && DataSharingAllowedCheckoutExpress.invalid">
                  {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
                </p>
            </li>
            <li class="list-group-item mb-5" *ngIf="customsInspection">
              <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                <input type="checkbox" [ngClass]="{ 'has-error' : CustomsForInspectionCheckoutExpress.dirty && CustomsForInspectionCheckoutExpress.invalid }"
                  name="customsForInspectionCheckoutExpress" id="customsForInspectionCheckoutExpress" #CustomsForInspectionCheckoutExpress="ngModel" [ngModel]='upsellFormData.set' required
                  (change)="customsForInspection($event)">
                <label for="customsForInspectionCheckoutExpress" class="text-caption" [innerHTML]="appCopy.panelHeader['customsForInspection'+selectedLanguage]"></label>
              </div>
              <p class="help-block text-danger" *ngIf="CustomsForInspectionCheckoutExpress.dirty && CustomsForInspectionCheckoutExpress.invalid">
                {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
              </p>
            </li>
            <li *ngIf="ccdCheckbox" class="list-group-item mb-5 check-customVerification">
              <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                <input type="checkbox" [ngClass]="{ 'has-error' : customVerificationCheckoutExpress.dirty && customVerificationCheckoutExpress.invalid }"
                  name="customVerificationCheckoutExpress" id="customVerificationCheckoutExpress" #customVerificationCheckoutExpress="ngModel" [ngModel]='upsellFormData.set' required
                  (change)="iVerify($event)">
                <label for="customVerificationCheckoutExpress" class="text-caption"
                  [innerHTML]="appCopy.panelHeader['customVerificationCheckLabel'+selectedLanguage]"></label>
              </div>
              <p class="help-block text-danger" *ngIf="customVerificationCheckoutExpress.dirty && customVerificationCheckoutExpress.invalid">
                {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
              </p>
            </li>
            <li *ngIf="emiratesSkywards" class="list-group-item mb-5 check-customVerification">
              <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
                <input type="checkbox" [ngClass]="{ 'has-error' : skywardsMembershipCheckoutExpress.dirty && skywardsMembershipCheckoutExpress.invalid }"
                  name="skywardsMembershipCheckoutExpress" id="skywardsMembershipCheckoutExpress" #skywardsMembershipCheckoutExpress="ngModel" [ngModel]='upsellFormData.set'
                  (change)="skywardsCheck($event)">
                <label for="skywardsMembershipCheckoutExpress" class="text-caption"
                  [innerHTML]="appCopy.panelHeader['skywardsMembershipLable'+selectedLanguage]"></label>
              </div>
            </li>
          </ul>
        </form>
        <div class="paymentButtons">
          <span class="googlePayWrapper" *ngIf="paymentOptionsAvailable.gpay">
          <p id="googlepayValidation" name="googlepayValidation">Please use google pay button for your payment</p>
          <p id="googlepayRefile" name="googlepayRefile">You have update booking details please use google pay again.</p>
          <div class="g-pay amount-section">
            <google-pay-button
              [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'gPayBtnStandard' : 'gPayBtnAmend'"
              [environment]="env === 'prod' ? 'PRODUCTION' : 'TEST'" buttonType="plain" buttonColor="white" buttonSizeMode="small"
              (loadpaymentdata)="onLoadPaymentData($event)" [paymentRequest]="paymentRequest"
              [paymentAuthorizedCallback]="onPaymentAuthorizedData" (error)="onError($event)"
              [clickCallback]="onPressButton" value="Pay">
            </google-pay-button>
          </div>


          <!-- <div
            style="position: absolute; position: absolute; right: -8px;left: -8px; background-color: #ffffff8c; bottom: 0; top: 0;display: flex;"
            class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg style="left:-100px;" class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div> -->
          </span>
          <span *ngIf="paymentOptionsAvailable.apple" >
            <app-apple-pay #applePay (handleApplePay)="handleApplePay($event)"
              [isD2dService]="isD2dService" [showLoader]="showLoader"
              [disablePayButton]="disableBook || !phoneNumberValid || virtualBags===0"
              [bookingState]="bookingState"
              [paymenttype]="paymenttype"
              [price]="price"
              [appCopy]="appCopy"
              [selectedLanguage]="selectedLanguage">
            </app-apple-pay>
          </span>
        </div>
        <span class="or">or</span>
      </div>


    <app-booker-form #bookerForm [currentBooking]="currentBooking" [bookingState]="bookingState" [user]="user"
      (validatePhoneNumberParent)="handleValidatePhoneNumber($event)" (emailInputChange)="handleEmailInputChange()" [appCopy]='appCopy'
      [selectedLanguage]='selectedLanguage' [formData]="upsellFormData">
    </app-booker-form>
    <form #termsForm="ngForm" class="termForm" name="termsForm" ng novalidate *ngIf="bookingType !== 'amend'">
      <ul class="list-group margin-bottom-0">
        <li class="list-group-item mb-5">
            <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
              <input type="checkbox" [ngClass]="{ 'has-error' : DataSharingAllowed.dirty && DataSharingAllowed.invalid }"
              name="dataSharingAllowed" id="dataSharingAllowed" #DataSharingAllowed="ngModel" [ngModel]='upsellFormData.set' required
              (change)="iUnderstand($event)">
              <label for="dataSharingAllowed" class="text-caption">
                {{appCopy.panelHeader['dataSharingAllowedCheckLabel'+selectedLanguage]}}
              </label>
            </div>
            <p class="help-block text-danger" *ngIf="DataSharingAllowed.dirty && DataSharingAllowed.invalid">
              {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
            </p>
        </li>
        <li class="list-group-item mb-5" *ngIf="customsInspection">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : CustomsForInspection.dirty && CustomsForInspection.invalid }"
              name="customsForInspection" id="customsForInspection" #CustomsForInspection="ngModel" [ngModel]='upsellFormData.set' required
              (change)="customsForInspection($event)">
            <label for="customsForInspection" class="text-caption" [innerHTML]="appCopy.panelHeader['customsForInspection'+selectedLanguage]"></label>
          </div>
          <p class="help-block text-danger" *ngIf="CustomsForInspection.dirty && CustomsForInspection.invalid">
            {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
          </p>
        </li>
        <li *ngIf="ccdCheckbox" class="list-group-item mb-5 check-customVerification">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : customVerification.dirty && customVerification.invalid }"
              name="customVerification" id="customVerification" #customVerification="ngModel" [ngModel]='upsellFormData.set' required
              (change)="iVerify($event)">
            <label for="customVerification" class="text-caption"
              [innerHTML]="appCopy.panelHeader['customVerificationCheckLabel'+selectedLanguage]"></label>
          </div>
          <p class="help-block text-danger" *ngIf="customVerification.dirty && customVerification.invalid">
            {{appCopy.panelHeader['errorTextDataSharingAllowedCheckRequired'+selectedLanguage]}}
          </p>
        </li>
        <li *ngIf="emiratesSkywards" class="list-group-item mb-5 check-customVerification">
          <div class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0">
            <input type="checkbox" [ngClass]="{ 'has-error' : skywardsMembership.dirty && skywardsMembership.invalid }"
              name="skywardsMembership" id="skywardsMembership" #skywardsMembership="ngModel" [ngModel]='upsellFormData.set'
              (change)="skywardsCheck($event)">
            <label for="skywardsMembership" class="text-caption"
              [innerHTML]="appCopy.panelHeader['skywardsMembershipLable'+selectedLanguage]"></label>
          </div>
        </li>
      </ul>
    </form>

    <!-- amend booker/contact details-->
    <button id="formBookerAmend-submit" type="button" class="btn btn-primary btn-block margin-top-12" value="Pay"
      *ngIf="bookingType === 'amend' && bookingAmendSection === 'booker'" (click)="handleBookerAmend()"
      [disabled]="showAmendLoader">

      <div class="loader-container-btn" *ngIf="showAmendLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{appCopy.panelHeader['buttonSaveDetails'+selectedLanguage]}}
    </button>

    <!-- pay by invoice checkbox and hr -->
    <!-- <div class="form-group" *ngIf="showInvoice">
      <div class="checkbox checkbox--default checkbox--small">
        <input type="checkbox" name="payByInvoice" id="payByInvoice" (change)="togglePayByInvoice($event)">
        <label for="payByInvoice"
          class="text-muted">{{appCopy.panelHeader['payByInvoiceCheckLabel'+selectedLanguage]}}</label>
      </div>
    </div>
    <hr class="margin-top-16 margin-bottom-16" *ngIf="showInvoice"> -->

    <!-- <div class="alert flex flex--space-between alert-info-light" *ngIf="hasPriceDifference && bookingType === 'amend'">
      <p>Price difference to be paid: £{{ priceDifferenceAmout }}</p>
    </div> -->

    <!-- <div *ngIf="showOverridePayment"
      class="checkbox checkbox--default checkbox--small margin-bottom-16">
      <input type="checkbox"
        name="overridePayment"
        id="overridePayment"
        [(ngModel)]="overridePayment">
      <label for="overridePayment" class="text-caption">Do not charge the customer for this amendment</label>
    </div> -->

    <app-standard-payment #standardPaymentForm *ngIf="!userHasCards && bookingAmendSection !== 'booker'"
      [bookingState]="bookingState" [user]="user" [price]="price" [oldprice]="oldprice" [isVisible]='isVisible'
      [appCopy]="appCopy" [selectedLanguage]='selectedLanguage' [payByInvoice]="payByInvoice"
      [overridePayment]="overridePayment" [billingAddress]="billingAddress" [billingAddressValid]="billingAddressValid"
      [flightDirection]="flightDirection" [isCustomerSupport]="isCustomerSupport" (checkPromo)="checkPromo($event)"
      (handlePaymentType)="recievePaymentType($event)" [formData]="upsellFormData"
      [PaymentTypeAvailable]="paymentOptionsAvailable" [paymenttype]="paymenttype"
      [bookingAmendType]="bookingAmendType">
    </app-standard-payment>

    <div class="panel amendPyment-panel" *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker' && bookingState.bookingDetails.bookingAmendType !== 'refund'">


      <div class="payment-option googlePay">
        <google-pay-button
            [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'gPayBtnStandard' : 'gPayBtnAmend'"
            [environment]="env === 'prod' ? 'PRODUCTION' : 'TEST'" buttonType="plain" buttonColor="white" buttonSizeMode="small"
            (loadpaymentdata)="onLoadPaymentData($event)" [paymentRequest]="paymentRequest"
            [paymentAuthorizedCallback]="onPaymentAuthorizedData" (error)="onError($event)"
            [clickCallback]="onPressButton" value="Pay">
          </google-pay-button>

      </div>
      <div class="payment-option" *ngIf="paymentOptionsAvailable.apple">
        <app-apple-pay #applePay (handleApplePay)="handleApplePay($event)"
          [isD2dService]="isD2dService" [showLoader]="showLoader"
          [disablePayButton]="disableBook || !phoneNumberValid || virtualBags===0"
          [bookingState]="bookingState"
          [paymenttype]="paymenttype"
          [price]="price"
          [appCopy]="appCopy"
          [bookingAmendType]="bookingState.bookingDetails.bookingAmendType"
          [selectedLanguage]="selectedLanguage">
        </app-apple-pay>

      </div>
    </div>

    <app-recurring-payment #recurringPaymentForm *ngIf="userHasCards && bookingAmendSection !== 'booker'"
      [bookingState]="bookingState" [user]="user" [price]="price" [appCopy]="appCopy"
      [selectedLanguage]='selectedLanguage' [payByInvoice]="payByInvoice" [overridePayment]="overridePayment"
      (deleteSavedCard)="deleteSavedCard($event)" [billingAddress]="billingAddress"
      [billingAddressValid]="billingAddressValid" [flightDirection]="flightDirection"
      [isCustomerSupport]="isCustomerSupport" (handlePaymentType)="recievePaymentType($event)" [formData]="upsellFormData"
      [PaymentTypeAvailable]="paymentOptionsAvailable" [paymenttype]="paymenttype">
    </app-recurring-payment>





    <div class="reveal" *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker'">

      <div class="reveal__content">
        <div class="panel-body">
          <app-price-breakdown  [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"
            [price]="price" [timeslot]="bookingState.bookingDetails.timeslot"
            [amendType]="bookingState.bookingDetails.bookingAmendType" [premiumSurcharge]="premiumSurcharge">
          </app-price-breakdown>
        </div>
        <hr class="margin-top-0 margin-bottom-0">
      </div>

      <div class="reveal__toggle panel-body" appRevealToggle>
        <div class="flex-always flex--space-between">
          <div>
            <p>{{appCopy.panelHeader['total'+selectedLanguage]}}</p>
            <a class="link reveal__closed text-600"
              href="javascript:void(0)">{{appCopy.panelHeader['viewPriceBreakdown'+selectedLanguage]}}</a>
            <a class="link reveal__open"
              href="javascript:void(0)">{{appCopy.panelHeader['hidePriceBreakdown'+selectedLanguage]}}</a>
          </div>
          <p class="total-price" *ngIf="price.priceHistory.majorPriceDifference !== 0">
            <span *ngIf="bookingState.bookingDetails.bookingAmendType === 'payment'">+ </span>
            <span *ngIf="bookingState.bookingDetails.bookingAmendType === 'refund'">- </span>
            {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
            price.priceHistory.majorAmount }}
          </p>
        </div>
      </div>

    </div>

    <div class="panel panelPaymentOption">
      <div class="row margin-bottom-8" *ngIf="!payByInvoice && bookingType !== 'amend'">

        <div class="mobileShowPromo">
          <div class="col-lg-12 col-md-12">
            <app-promo [price]="price" [user]="user" [togglePromo]="togglePromo" [appCopy]="appCopy"
              [selectedLanguage]='selectedLanguage'>
            </app-promo>
          </div>

          <!--- Begin Mention Me referee placeholder div -->
          <div id="mmWrapper" class="col-lg-6 col-md-6 margin-top-16 margin-bottom-16 mmWrapper--link" (click)="togglePromo = true"></div>
          <!--- End Mention Me referee placeholder div -->
        </div>


      </div>
      <div class="row">
        <div [ngClass]="bookingType !== 'amend' && bookingAmendSection !== 'booker' ? 'col-md-12' : 'col-md-12'">
          <!-- standard submit button-->
          <div class="margin-bottom-8 clearfix"
            *ngIf="bookingType !== 'amend' && bookingAmendSection !== 'booker'">

            <button id="formPayment-submit" style="background-color: #7850FA;color: white; height: 48px;" type="button"
              class="btn btn-primary btn-block tether-payment-target" [disabled]="disableBook || !phoneNumberValid || virtualBags===0"
              value="Pay" (click)="handlePaymentSubmit()">
              {{appCopy.panelHeader['buttonConfirm'+selectedLanguage]}}&nbsp;
              <span *ngIf="!isD2dService" class="price_mobile_view">
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol === 'CHF'">{{ price.totalPrice.currencySymbol
                  + ' ' + price.totalPrice.majorAmount}}</span>
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol !== 'CHF'">{{ price.totalPrice.currencySymbol
                  + price.totalPrice.majorAmount }}</span>
                <div class="loader-container-btn" *ngIf="showLoader">
                  <div class="loader loader--white">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" />
                    </svg>
                  </div>
                </div>
              </span>

              <span *ngIf="isD2dService" class="price_mobile_view">
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol === 'CHF'">{{ price.totalPrice.currencySymbol + ' ' + getD2dDiscountPrice() }}</span>
                <span *ngIf="!showLoader && price.totalPrice.currencySymbol !== 'CHF'">{{ price.totalPrice.currencySymbol + getD2dDiscountPrice() }}</span>
                <div class="loader-container-btn" *ngIf="showLoader">
                  <div class="loader loader--white">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" />
                    </svg>
                  </div>
                </div>
              </span>
              &nbsp;{{appCopy.panelHeader['confirmPart2'+selectedLanguage]}}
            </button>
          </div>




          <!-- amend payment submit -->
          <div class="margin-bottom-16"
            *ngIf="bookingType === 'amend' && bookingAmendSection !== 'booker'">

            <button id="formPayment-submit" style="background-color: #7850FA;color: white; height: 48px;" type="button"
              class="btn btn-primary btn-block tether-payment-target" [disabled]="disableBook || !phoneNumberValid"
              value="Pay" (click)="handlePaymentAmend()">
              <div class="loader-container-btn" *ngIf="showLoader">
                <div class="loader loader--white">
                  <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" />
                  </svg>
                </div>
              </div>
              <span
                *ngIf="bookingState.bookingDetails.bookingAmendType === 'refund'">{{appCopy.panelHeader['confirmRefund'+selectedLanguage]}}</span>
              <span
                *ngIf="bookingState.bookingDetails.bookingAmendType !== 'refund'">{{appCopy.panelHeader['buttonConfirm'+selectedLanguage]}}</span>

                <span class="price_mobile_view">

                  <ng-template [ngIf]="bookingState.bookingDetails.bookingAmendType === 'refund'" [ngIfElse]="notRefund">
                    <span *ngIf="price.totalPrice.currencySymbol === 'CHF'">&nbsp;&nbsp;-&nbsp;{{
                      price.totalPrice.currencySymbol + ' ' + price.priceHistory.majorAmount}}</span>
                    <span *ngIf="price.totalPrice.currencySymbol !== 'CHF'">&nbsp;&nbsp;-&nbsp;{{ price.totalPrice.currencySymbol +
                      price.priceHistory.majorAmount }}</span>
                  </ng-template>

                  <ng-template #notRefund>
                    <span *ngIf="price.totalPrice.currencySymbol === 'CHF'">&nbsp;{{
                      price.totalPrice.currencySymbol + ' ' +price.priceHistory.majorAmount}}</span>
                    <span *ngIf="price.totalPrice.currencySymbol !== 'CHF'">&nbsp;{{ price.totalPrice.currencySymbol +
                      price.priceHistory.majorAmount }}</span>
                  </ng-template>

              </span>
              &nbsp;{{appCopy.panelHeader['confirmPart2'+selectedLanguage]}}
            </button>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p *ngIf="bookingType !== 'amend' || (bookingType === 'amend' && bookingAmendSection !== 'booker')"
            class="text-caption text-dark-blue margin-top-8 margin-bottom-8" [innerHTML]="appCopy.termsAndConditions['content'+selectedLanguage]">
          </p>
        </div>
      </div>
      <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="text-dark-green margin-bottom-8">
        <i class="icon icon-cut-off-checkmark"></i>{{' '}}
        {{appCopy.panelHeader['cutOfTiming'+selectedLanguage].replace('%s', cutOffTimeWindowDate).replace('%s', cutOffTimeWindowTime)}}
      </p>
      <p *ngIf="bookingType !== 'amend' && cutOffTimeWindowDate" class="text-dark-green">
        <i class="icon icon-cut-off-checkmark"></i>{{' '}}
        {{appCopy.panelHeader['endorseBy'+selectedLanguage].replace('%s', bookingAirportName).replace('%s', bookingAirlineName)}}
      </p>

    </div>
    <div class="challengerModal">
      <h1 *ngIf="showChallengeShopper" class="margin-bottom-32">
        {{appCopy.panelHeader['titleChallengeShopper'+selectedLanguage]}}</h1>
      <div id="threedsContainer"></div>
      <p *ngIf="showChallengeShopper" class="margin-top-24"
        [innerHTML]="appCopy.panelHeader['contentChallengeShopper'+selectedLanguage] + this.bookingState.bookingDetails.bookingReference">
      </p>
    </div>

    <div *ngIf="threeDsPaymentType === 'redirect'" class='3ds1_redirection_form'>
      <form #threeDs1Form method="POST" action="{{threeDs1Data.issueUrl}}" id="3dform">
        <input type="hidden" name="PaReq" value="{{threeDs1Data.pReq}}" />
        <input type="hidden" name="MD" value="{{threeDs1Data.md}}" />
        <input type="hidden" name="TermUrl" value="{{threeDs1Data.termUrl}}" />
        <noscript>
            <br>
            <br>
            <div style="text-align: center">
                <h1>Processing your 3D Secure Transaction</h1>
                <p>Please click continue to continue the processing of your 3D Secure transaction.</p>
                <input type="submit" class="button" value="continue"/>
            </div>
        </noscript>
      </form>
    </div>

  </div>
</div>
